__webpack_require__.p = "https://s3.eu-central-1.amazonaws.com/dev.pult.ecommerce.kz/templates/react/";